import { render, staticRenderFns } from "./fungsi.vue?vue&type=template&id=0666875e&"
import script from "./fungsi.vue?vue&type=script&lang=js&"
export * from "./fungsi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports